<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="page_header_wrap" :class="{ filters_open: filtersList }">
        <div class="page_header">
          <div>
            <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>SDK & Documentation</h2>
          </div>
          <div class="page_actions"> 
            <div class="page_search">
              <input
                v-model="serch_title"
                  class="search_field"
                  type="text"
                  @keyup="onEnter"
                  placeholder="Search By Name/Version"
                />
            </div>
            <span v-if="activeUserInfo.roleId == 1" class="secondary_btn add" @click="createSdk()">
              Add SDK Release
            </span>
            <!-- <button  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
              <span class="material-icons"> filter_list</span>Filters
            </button> -->
          </div>
        </div> 
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
             <div
      ref="filterCard" 
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full marb10">
        <label class="text-sm opacity-75">Search</label>
          <!-- <input
           v-model="serch_title"
            class="search_field"
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Name/Version"
          /> -->
        </div>
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full d-flex align-end justify-end marb10">
        <button @click="clearFilters()" class="secondary_btn">
            Clear
          </button>
          <button class="primary_btn marl15" @click="getSdkList() , filtersList = !filtersList">
            Apply
          </button>
        </div>
        <!-- <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex justify-end align-end"
        >
          <button v-if="activeUserInfo.roleId == 1" class="secondary_btn add" @click="createSdk()">
            Upload SDK
          </button>
        </div> -->
      </div>
    </div>
      
    </div>




    <!-- <div class="invite_btn">
      <span v-if="activeUserInfo.roleId == 1" class="secondary_btn add" @click="createSdk()">
        Add SDK Release
      </span>
    </div> -->
    
    <vs-table :data="sdkList" noDataText="">
      <template slot="thead">
        <vs-th> SDK
        <!-- <a  @click="sortMe('title')" v-bind:class="{
                  sort_ascending: sortKeys['title'] == 1,
                  sort_descending: sortKeys['title'] != 1,
                }"
                > SDK</a> -->
         </vs-th>
          <vs-th> 
               <a  @click="sortMe('version')" v-bind:class="{
                  sort_ascending: sortKeys['version'] == 1,
                  sort_descending: sortKeys['version'] != 1,
                }"
                > Version</a>
            
         </vs-th>
         <vs-th v-if="activeUserInfo.roleId == 1"> 
           <a  @click="sortMe('statusName')" v-bind:class="{
                  sort_ascending: sortKeys['statusName'] == 1,
                  sort_descending: sortKeys['statusName'] != 1,
                }"
                >Status</a>
         
         </vs-th>
          <vs-th v-if="activeUserInfo.roleId == 1"> 
            
         Available To
         </vs-th>
        <vs-th class="no_wrap"> 
        <a  @click="sortMe('createdOn')" v-bind:class="{
                  sort_ascending: sortKeys['createdOn'] == 1,
                  sort_descending: sortKeys['createdOn'] != 1,
                }"
                > Released on</a>
               
        </vs-th>
         <vs-th>
          Action
        </vs-th>   
      </template>
       <template v-if="sdkList && sdkList.length > 0">
        <!-- <template v-for="(sdk ,index) in sdkList" > -->
          <vs-tr v-for="(sdk ,index) in sdkList" :key="index">
            <vs-td class="sdk_details_td sdk_list">
              <div class="sdk_details"> 
                 <template v-if="activeUserInfo.roleId == 1">
                      <label @click="getDetails(sdk._id)" >{{sdk.title}}</label>
                 </template>
                 <template v-else>
                  <label>{{sdk.title}}</label>
                 </template>
               
                <p v-if="sdk.title!=sdk.description"> {{sdk.description}} </p>
                <!-- <span> {{sdk.version}}</span>  -->
                                
                <!-- <br> -->
                <ul>
                 <li v-if=" checkDocumentExists(sdk) && sdk.docReleasePath && apiURL"><a  target="_blank" :href="apiURL+sdk.docReleasePath" > Releases Notes </a></li>
                  <li v-if="checkDocumentExists(sdk) && sdk.docServePath && apiURL"><a  target="_blank" :href="apiURL+sdk.docServePath" > API Documentation </a></li>
                  <li v-if="checkDocumentExists(sdk) && sdk.docServePath && apiURL"><a  target="_blank" :href="apiURL+sdk.sdkServePath" > SDK Documentation </a></li>

                </ul>
              
              </div>

            </vs-td>
            <vs-td> {{sdk.version }}</vs-td>
            <!-- <vs-td v-if="activeUserInfo.roleId == 1"> {{sdk.publish ? 'Publish': 'Unpublish' }}</vs-td> -->
            <vs-td v-if="activeUserInfo.roleId == 1">
                <!-- <span class="td_status" :class="{'pending':item.statusId==1 , 'active':item.statusId==2 , 'inactive':item.statusId== 3 ,'deleted':item.statusId==4}"
                >{{item['statusDetails']['name']}}
                </span>  -->
                <template v-if="sdk['statusDetails']">
                {{sdk['statusDetails']['name']}}
                </template>
              </vs-td>
              <vs-td v-if="activeUserInfo.roleId == 1"> 
                <template v-if="sdk.companyIds && sdk.companyIds.length > 0">
                  Company
                </template>
                  <template v-else-if="sdk.cusIds && sdk.cusIds.length > 0">
                    Users
                </template>
                  <template v-else>
                    Everyone
                </template>
              </vs-td>
            <vs-td> {{sdk.createdOn | formatDate }}
              <br>
              <small>{{ sdk.createdOn | formatTime}}</small>   
            </vs-td>
          
            <vs-td class="w-80" >
          
            <input type="hidden" v-if="sdk.sdk" v-bind:id="'copy_url_'+sdk._id"  v-bind:value="sdk.sdk.path" >
                        
                <vs-dropdown vs-trigger-click>
                  <a class="a-icon" href.prevent> 
                    <span class="material-icons">more_vert</span>
                  </a>

                  <vs-dropdown-menu>  

                    <vs-dropdown-item v-if="activeUserInfo.roleId == 1 && sdk.statusId == 2" @click="publishSdk(sdk ,true)">
                      
                          Republish
                      
                    </vs-dropdown-item >             
                    
                    <vs-dropdown-item v-if="activeUserInfo.roleId == 1" @click="publishSdk(sdk ,false)">
                      
                          {{sdk.statusId == 2?'UnPublish':'Publish'}}
                      
                    </vs-dropdown-item >
                    <vs-dropdown-item v-if="activeUserInfo.roleId == 1" @click="getDetails(sdk ,true)"> Edit  
                    </vs-dropdown-item >
                    
                    <template v-if="activeUserInfo.roleId == 2 && sdk.sdk">
                        <vs-dropdown-item v-if=" sdk.sdk.path && sdk.sdk.path !='' && activeUserInfo.settings.indexOf(1) >-1" @click="copy_url(sdk ,index)">Copy SDK URL </vs-dropdown-item >
                      <vs-dropdown-item v-if="activeUserInfo.settings.indexOf(1) >-1" @click="trackClicks({ type:'download','sdkVersion':sdk['version'], 'sdkId':sdk['_id']});download_file(sdk.sdk ,true) ;" >Download SDK</vs-dropdown-item>
                      <vs-dropdown-item v-if="activeUserInfo.settings.indexOf(2) >-1"  @click="download_file(sdk.document,true)"> Download Documentation</vs-dropdown-item>
                  
                      
                    </template>
                    <template v-else>
                      <vs-dropdown-item v-if="sdk.sdk &&  sdk.sdk.path && sdk.sdk.path !=''" @click="copy_url(sdk ,index)">Copy SDK URL </vs-dropdown-item >
                      <vs-dropdown-item @click="download_file(sdk.sdk ,true)" >Download SDK</vs-dropdown-item>
                      <vs-dropdown-item @click="download_file(sdk.document,true)"> Download Documentation</vs-dropdown-item>
                   <!-- <vs-dropdown-item  ><router-link :to="'/sdkAnalytics/'+sdk['_id']" > Analytics </router-link></vs-dropdown-item>-->
                    <vs-dropdown-item v-if="activeUserInfo.roleId == 1"  @click="goToAnalytics(sdk)" >Analytics </vs-dropdown-item>
                     <vs-dropdown-item v-if="activeUserInfo.roleId == 1"  @click="goToSentMails(sdk)" >Sent Mails </vs-dropdown-item>
                 
                    

                    </template>
                  </vs-dropdown-menu>
                </vs-dropdown>               
            </vs-td>
          </vs-tr>       
        <!-- </template> -->
      </template>
        <template v-else>
          <tr v-if="!loading">
            <td class="center-align" colspan="7">No Sdks Found!</td>
          </tr>
        </template>
    </vs-table>
    <div class="pagination_wrap" v-if="totalpages > 0">
      <div class="pagination_content" >
        <h6>Show Records</h6>
        <multiselect
          :multiple="false" 
            @input="change_perPage()"
          placeholder="Page"
          
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :preserve-search="true"
          
          v-model="perPage" :options="perPeges" >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            
          </multiselect>
      </div>
      <vs-pagination
        :total="totalpages"
        :max="7"
        v-model="page"
        @input="getSdkList()"
      />
    </div>

    <vs-popup
      v-if="popupcreateticket"
      class="holamundo"
      :active.sync="popupcreateticket"
      :title="popupTitle"
    >
      <div class="createticket_form form_section">
        <form autocomplete="off" >
          <ul>
            <li>
              <div class="form-group">
              <label class="form_label">Title*</label>
              <vs-input
                v-validate="'required|min:3'"
                name="Title"
                icon-no-border
                icon-pack="feather"
                 
                v-model="newSdk.title"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("Title")
              }}</span>
              </div>
            </li>
             
            
            <li>
              <div class="form-group">
              <label class="form_label">Version*</label>
              <vs-input
                v-validate="'required|min:1'"
               
                name="Version"
                icon-no-border
                icon-pack="feather"                 
                v-model="newSdk.version"
                class="w-full"
                 
              />
              <span class="text-danger text-sm">{{
                errors.first("Version")
              }}</span>
              </div>
            </li>
            <li>
              <div class="form-group">
              <label class="form_label">Description*</label>
              <vs-textarea
                v-validate="'required|min:10'"               
                name="Description"
                icon-no-border
                icon-pack="feather" 
                v-model="newSdk.description"
                class="w-full"
              />
              
              <span class="text-danger text-sm">{{
                errors.first("Description")
              }}</span>
              </div>
            </li>
            <li>
           
              <div class="radio_wrap" >
                <vs-radio v-model="radios1" @change="onRadio" vs-name="radios1" vs-value="EveryOne">Everyone</vs-radio>
                <vs-radio v-model="radios1" @change="onRadio" vs-name="radios1" vs-value="Client">Company </vs-radio>  
                <vs-radio v-model="radios1" @change="onRadio" vs-name="radios1" vs-value="Customer">User</vs-radio>              
              </div>
               
            </li>
               <li v-if="radios1=='Client'">
              <div class="form-group">
              <label class="form_label">Company</label>
              <multiselect
                v-model="newSdk.companyIds"
                :options="companies"
                :close-on-select="false"
                :clear-on-select="false"
                :hide-selected="true"
                :preserve-search="true"
                
                :multiple="true"
                label="name"
                placeholder="Select Company"
                track-by="name"  
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span
                    class="multiselect__selectcustom"
                    v-if="values.length && !isOpen"
                    >{{ values.length }} Company(s) selected</span
                  >
                  <span
                    class="multiselect__selectcustom"
                    v-if="values.length && isOpen"
                  ></span>
                </template>
                <span slot="noResult">No Company Found</span>

              </multiselect>
              </div>
            </li>
            <li v-if="radios1=='Customer'" > 
              <div class="taggable">
                <div class="form-group">
                <label class="form_label">Users</label>
                  <multiselect 
                        v-model="newSdk.cusIds" 
                        :options="sdkUsers" 
                        :clear-on-select="false"
                        :close-on-select="false"
                        :hide-selected="true"
                        :multiple="true"
                        :preserve-search="true"
                         @search-change="searchCustomerList"
                        placeholder="Select Users"
                        label="name"
                        track-by="name"
                        id="customer"
                          >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" 
                          v-if="values.length && !isOpen">{{ values.length }} User(s) selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                        <span slot="noResult">No Users Found</span>
                  </multiselect>
                </div>
              </div>
            </li>
            <li @click="documents=[]">
              <!-- <vs-upload
                multiple
                text="Upload SDK files"
                automatic
                @on-success="successUpload"
                 
              />   sdkBucketList -->
              <!--<div class="form-group">
              <label class="form_label">SDK Files</label>

              <div class="files_wrap">
                          <file-upload v-model="documents" class="file-upload-input"
                          accept="zip,application/zip,application/x-zip,application/x-zip-compressed"  :name="'sdkfiles'" data-vv-as="Upload SDK files"
                            :multiple="false" @input="upload(documents ,'sdk')" >
                            <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
                          </file-upload>
                          <span class="text-danger text-sm"
              v-show="errors.has('sdkfiles')">{{ errors.first('sdkfiles') }}</span>
              </div>
            <ul  class="uploaded-list">
              <li  v-if="newSdk.sdk !=null" ><vs-chip @click="newSdk.sdk =null" :name="'sdkRemoveSelected'"   closable> {{ newSdk.sdk!=null?newSdk.sdk.name:'' }} </vs-chip></li>
             
              
            </ul>
              </div>-->

              <div class="taggable">
                <div class="form-group">
                <label class="form_label">SDK File*</label>
                  <multiselect 
                        v-model="newSdk.sdk" 
                        :options="sdkBucketList" 
                        :clear-on-select="false"
                        :close-on-select="true"
                        :hide-selected="false"
                        :multiple="false"
                        :preserve-search="true"
                        placeholder="Select SDK File"
                        label="name"
                        track-by="name"
                        id="SDK_File"
                          >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" 
                          v-if="values.length && !isOpen">{{ values.length }} SDK File(s) selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                        <span slot="noResult">No SDK Files Found</span>
                  </multiselect>
                
                </div>
              </div>


           

            </li>
            <li @click="documents=[]" >
              
              <div class="form-group">
              <!--v-if="(newSdk.title !='' && newSdk.title !=null) && newSdk.version !='' && newSdk.version !=null "--->
              <template  >
            <label class="form_label">SDK Document<!-- (zip file only)---></label>
             <multiselect 
                        v-model="newSdk.document" 
                        :options="sdkDocBucketList" 
                        :clear-on-select="false"
                        :close-on-select="true"
                        :hide-selected="false"
                        :multiple="false"
                        :preserve-search="true"
                        placeholder="Select SDK File"
                        label="name"
                        track-by="name"
                        id="SDK_File"
                          >
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" 
                          v-if="values.length && !isOpen">{{ values.length }} SDK File(s) selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                        <span slot="noResult">No SDK Files Found</span>
                  </multiselect>
                
            <!--<div class="files_wrap" v-if="(newSdk.title !='' && newSdk.title !=null) && newSdk.version !='' && newSdk.version !=null ">
            <file-upload v-model="documents" class="file-upload-input"
            accept="zip,application/zip,application/x-zip,application/x-zip-compressed"  :name="'documents'" data-vv-as="Upload SDK documents"
              :multiple="false" @input="upload(documents,'document')" >
              <img class="file-icon" src="@/assets/images/file-icons/file-upload.svg"> Upload
            </file-upload>
            <span class="text-danger text-sm"
              v-show="errors.has('documents')">{{ errors.first('documents') }}</span>
            </div>-->


            </template>
            
            
            <ul  class="uploaded-list">
            
              <li v-if="newSdk.document !=null && checkDocument" ><vs-chip @click="newSdk.document =null;newDocument=true" :name="'sdkdocumentRemoveSelected'"   closable> {{ newSdk.document !=null?newSdk.document.name:'' }} </vs-chip></li>
             
             <!-- <li><vs-chip @click="remove(indx, 'document')" :name="'sdkdocumentRemoveSelected'" v-for="(other, indx) in newSdk.document" :key="indx"  closable> {{ other.name }} </vs-chip></li>-->
            </ul>
  </div>
            </li>
          </ul>
        </form>
        <div class="form_actions">
          <span></span>
          <button v-if="isAdd"
          :disabled="validateForm"
            class="close_popup primary_btn"
            @click="newDocument =false; createSdkAction()"
          >
            Create
          </button>
           <button v-else
            :disabled="validateForm"
            class="close_popup primary_btn"
            @click="updateSdkAction()"
          >
            Update
          </button>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      :active.sync="publishPopup"
      :title="publishPopupTitle"
    >
      <div class="createticket_form">
        <form v-if="!(newSdk.statusId == 2) || isRepublish" class="w-full">
        <div class="form-group w-full">
          <label class="form_label">Mail Subject</label>
           <vs-input
            v-validate="'required|min:5'"
            data-vv-as="Mail Subject"
            name="Subject"
            icon-no-border
            icon-pack="feather" 
            v-model="mailSubject"
            autocomplete="off"
            class="w-full"
       />
     <span class="text-danger text-sm">{{
          errors.first("Subject")
        }}</span>
        </div>

           <div class="form-group w-full">
        <label class="form_label">
            Mail Content
       <!-- Description  -->
        </label>
        <ckeditor  v-validate="'required|min:10'" :editor="editor" v-model="pubContent" :config="editorConfig"></ckeditor>
                
        <!--<vs-textarea
          v-validate="'required|min:10'"               
          name="Description"
          icon-no-border
          icon-pack="feather" 
          v-model="pubContent"
          class="w-full"
        />-->
        
        <span class="text-danger text-sm">{{
          errors.first("Description")
        }}</span>
        </div>
   <!-- sdkHaveOnlyUsers ==  {{sdkHaveOnlyUsers}}  isRepublish =={{isRepublish}}-->
        <div class="form-group w-full" v-if="isRepublish && !sdkHaveOnlyUsers">
 
         
          <div class="flex radio-group">
            
            <vs-radio v-model="sendMailToAll"  :vs-value="true" class="mr-4"> Send  Mail to all</vs-radio>

            <vs-radio v-model="sendMailToAll"  :vs-value="false"> Send  Mail to only new users</vs-radio>
          
          </div>
          
        </div>
        
          
        </form>
       
        <!--<p>
          Are you sure want to {{newSdk.statusId == 2?'UnPublish':'Publish'}} this SDK ?
        </p>-->
        <div class="form_actions">
       
          <span class="secondary_btn" @click="publishPopup=false">Close</span>
          <button class="close_popup primary_btn marl15" :disabled="(publishPopupTitle != 'UnPublish')&& (checkMailContent || pubContent == null || errors.any() || pubContent == '' || mailSubject=='')" @click="publishAction()">
           
            {{publishPopupTitle}}
          </button>
        </div>
      </div>
    </vs-popup>
    
  </div>
</template>

<script>
import axios from '../../../axios.js' 

import vSelect from 'vue-select'
import FileUpload from "vue-upload-component/src";
import Multiselect from "vue-multiselect-inv";
import _ from "lodash";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Vue from 'vue';
Vue.use( CKEditor );
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: {
    vSelect,
    FileUpload,
    Multiselect
  },
 computed: {
  checkDocument(){
    if(_.has(this.newSdk ,'document') && this.newSdk['document'] !=null  ){
       if(_.has(this.newSdk.document ,'name') && ( this.newSdk['document']['name']!='' &&  this.newSdk['document']['name']!=null) ){
         return true;
       }else{
         return false;
       }

    }else{
      return false;
    }
     
  },
   checkMailContent(){
     let regex = /(<([^>]+)>)/ig ;
     let result = this.pubContent.replace(regex, "");
     let replaced = result.split(' ').join('');
     if(replaced){
       return false;
     }else{
       return true;
     }


   },
    validateForm () {
     // return this.errors.any() || this.newSdk.sdk ==null || this.newSdk.document ==null || (this.newSdk.title =='' || this.newSdk.title ==null) || (this.newSdk.description =='' || this.newSdk.description ==null) || (this.newSdk.version =='' || this.newSdk.version ==null)
    let return_value = false;
    if(this.errors.any() || (this.newSdk.title =='' || this.newSdk.title ==null) || (this.newSdk.description =='' || this.newSdk.description ==null) || (this.newSdk.version =='' || this.newSdk.version ==null)
    || (this.radios1=='Client' && this.newSdk.companyIds.length<=0) || (this.radios1=='Customer' && this.newSdk.cusIds.length<=0)
    
    ){
      return_value = true;
    }

    return return_value;

    },
    // validateCompanies() {
    //   return this.companyIds.length > 0
    // },
    // validateCus() {
    //   return this.cusIds.length > 0
    // },
    activeUserInfo () {
      return this.$store.state.auth.user
    }
  },
  data: () => ({
    loading:true,
    newDocument:false,
    editor: ClassicEditor,
    editorConfig: {
        // The configuration of the editor.
       toolbar: [ 'bold', 'italic', '|', 'undo','redo' ,"indent" ,"Outdent" ,'NumberedList', 'BulletedList', ],
         //removeButtons:["Image"]
        
    },
    filtersList: false,
    callFromSort:false,
    radios1: 'EveryOne',
    // Filter Options
    apiURL:null,
    popupTitle:'Add SDK Release',
    isAdd:true,
    documents:[],
    companyIds: [],
    cusIds: [],
    textarea: '',
    popupcreateticket: false,
    pubContent: '',
    sendMailToAll:true,
    mailSubject:'',
    selected: '',
    searchQuery: '',
       docPrivew:false,
     docValue:'',
     docType:"",
     selectedFile:null,
     companies: [],
     sdkUsers: [],

    ////////////
    serch_title: "",
    sortKey: {},
    sortKeys: {
      title: 1,
      createdOn: -1,
      version: -1,
      statusName: -1,
    },
    sdkList: [],
    perPeges: [25, 50, 75, 100],
    page: 1,
    perPage: 25,
    
    totalpages: 0,
    newSdk:{
      "description":"",
      "title": "",
      "version": "",
      "sdk": null,
      "document": null
    },
    publishPopup:false,
    publishPopupTitle:'',
    sdkBucketList:[],
    sdkDocBucketList:[],
    sdkHaveOnlyUsers:false,
  }),
  methods: {
    

    checkDocumentExists(sdk){
 
     if(_.has(sdk ,"document") && sdk['document']!=null){
       if(sdk['document']['path']){
         return true;
       }else{
         return false;
 
       }
       
     }else{
       return false;
     }
 
    },
    
    getMailContent(id){
      this.$store.dispatch('getMailContent', {"sdkId":id})
      .then((res)=>{
        if(res){
          
          this.pubContent =res['body'];
          this.mailSubject =res["subject"];
        }

      })
      .catch((err)=>{
        console.log(err);
      });
      
    },

     goToAnalytics(item){
      this.$router.push('/sdkAnalytics/'+item['_id']);
    },
    goToSentMails(item){
        this.$router.push('/sent-emails/?filter='+item['_id']);
    },
    getsdkBucketList(type='sdkBucketList'){
      let payload = {sdkBucket:true};
      if(type=='sdkDocBucketList'){
        payload = {sdkBucket:true ,sdkDocument:true};
      }
       this.$store
        .dispatch("getsdkBucketList", payload)
        .then((response) => {
         
          this[type] = response;
         
        })
        .catch((err) => {
          console.log(err);
          
        });

    },
    trackClicks(data ={ type:"copy","sdkVersion":'', "sdkId":''}){
      
     let viewasCu =  localStorage.getItem('ViewAsCustomer');
      if(data.type !="" && this.activeUserInfo.roleId == 2 && (viewasCu==undefined || viewasCu ==null) )
        this.$store.dispatch("auth/trackClicks" ,data);
    },

    copy_url(data ,index){
        let value = data['sdk']

        if(_.has(value , "path")){
          value['url'] = value['path'];
          data['sdk']['url'] =  value['path'];
        }
        if(_.has(value , "url")){
          value['path'] = value['url'];
          data['sdk']['path'] =  value['path'];
        }
         // alert(JSON.stringify(data))    

        let postdata = { keyName: value.path, sdkBucket:true ,"sdkVersion": data['version'], "sdkId":data['_id'] };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          value.path = response.data.result.data;
          data['sdk']['path'] = response.data.result.data;
          this.sdkList[index]['sdk']['path'] = response.data.result.data
                   
          setTimeout(()=>{  

              try {
                let testingCodeToCopy = document.querySelector('#copy_url_'+data['_id'])
                testingCodeToCopy.setAttribute('type', 'text')
                testingCodeToCopy.select()

                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                //alert();
                  testingCodeToCopy.setAttribute('type', 'hidden');
                  
                 
                  this.trackClicks( { "type":"copy","sdkVersion": data['version'], "sdkId":data['_id']});
                  
                this.$vs.notify({
                        text: 'URL was copied ' + msg,
                        title: "Success",
                        position:'top-right',
                        color:"success",
                        iconPack: 'feather',
                        icon:'icon-check',

                      });
                
              } catch (err) {
              //  alert(err);
                // alert('Oops, unable to copy');
                testingCodeToCopy.setAttribute('type', 'hidden')
                this.$vs.notify({
                        text: 'Please Try again',
                        title: "Error",
                        position:'top-right',
                        color:"danger",
                        iconPack: 'feather',
                        icon:'icon-check',

                      });

                
                
              }


          } ,100);



    });

    },
    onRadio() {
      this.newSdk.cusIds = []
      this.newSdk.companyIds = []
    },
    editSdk(item){
     
      this.popupTitle ="Edit SDK Release";
      this.popupcreateticket =true;
      this.isAdd =false;
    },
    getDetails(item,callFroEdit=false) {
     this.init()
      
      const payload = {
        sdkId: item._id,
      };
    
      this.$store
        .dispatch("sdkDetails", payload)
        .then((res) => {
          //this.newSdk = res
        //  console.log('newsdkk', this.newSdk)
            this.newSdk = Object.assign(this.newSdk, res)
            if (this.newSdk) {
              if (this.newSdk.companyIds && this.newSdk.companyIds.length > 0) {
                this.radios1 = 'Client';
                this.newSdk.companyIds = this.newSdk.companyDetails;
              //   this.companyIds = this.newSdk.companyIds;
              } else if (this.newSdk.cusIds && this.newSdk.cusIds.length > 0) {
                this.radios1 = 'Customer';
                 this.newSdk.cusIds = this.newSdk.customerDetails;
              //  this.cusIds = this.newSdk.cusIds;
              } else {
                this.radios1 = 'EveryOne'
              }
            } 
          if(callFroEdit){
            this.editSdk();
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    
    publishSdk(item , isRepublish=false){
      this.sdkHaveOnlyUsers =false;
      this.isRepublish =isRepublish;
      this.publishPopup =true;
      this.sendMailToAll = true;
      this.mailSubject ='';
     //alert(JSON.stringify(item));
     console.log(JSON.stringify(item));
    if((_.has(item ,"cusIds") && item['cusIds'].length>0) && (_.has(item ,"companyIds") && item['companyIds'].length<=0)){
       this.sdkHaveOnlyUsers =true;
    }
    
      this.newSdk = item;
      if (item.pubContent) {
        this.pubContent = item.pubContent;
      } else {
        
        this.pubContent = "New Sdk has released";
      }
      
        if(this.isRepublish){
           this.publishPopupTitle = 'Republish'
        }else if(this.newSdk.statusId == 2){
            this.publishPopupTitle = 'UnPublish';
            this.mailSubject ='UnPublish';
         }else{
            this.publishPopupTitle = 'Publish'
         }

      
       this.getMailContent(item['_id']);
       this.errors.clear();
       this.$validator.reset();
    },
    publishAction() {
      let payload = {

        "sdkId":this.newSdk['_id'],
        "pubContent": this.pubContent,
        "cusIds": this.newSdk.cusIds,
        "companyIds": this.newSdk.companyIds,
        "sendMailToAll":this.sendMailToAll,
        "pubSubject":this.mailSubject
        };
      if(this.newSdk.statusId == 2 && !this.isRepublish){
        payload.unPublishFlag = true;
        payload['pubSubject'] ='UnPublish';
      }
    
      this.$vs.loading();     
      this.$store
        .dispatch("publishAction", payload)
        .then((res) => {
          
          this.publishPopup = false;
          this.$vs.loading.close();
         
          this.getSdkList();
          this.$vs.notify({
            title: "Success",
            text: res.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.error_message.message,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    remove( type) {
        let fileName =""
      if(type =='sdk'){
        this.newSdk.sdk = null
      }else if(type =='document'){
        this.newSdk.document = null;
       
        
      }
      },
      upload(model ,type=''){
      let fileName ='';
      if(type =='sdk'){
      this.newSdk.sdk =null;
      }else if(type =='document'){
       
        
      this.newSdk.document =null;
      if(this.newSdk.title){
          let str = (this.newSdk.title).trim();
          let title = (str.split(' ').join('_'));
          fileName = fileName+title+"_"

        }
        if(this.newSdk.version){
          let str = (this.newSdk.version).trim();
          let version = (str.split(' ').join('_'));
           fileName = fileName+"_"+version;
           fileName =fileName+"_"+"documentation"
          
        }
      }

      

      
          let temp_count = 0;
          let formData = new FormData();
          this.disabled_btn = true;          
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
         
           var ext = mapper[0].extn.split('.').pop();
           if (['zip'].indexOf(ext.toLowerCase()) > -1) {
              this.$vs.loading();
              if (mapper.length > 0) {
              mapper.forEach((doc, index) => {
               
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  if(fileName!=''){
                      formData.append("fileName", fileName+"."+doc.extn);
                  }
                   
 
                  this.$store.dispatch("uploadS3File", formData).then(response => {
                      temp_count++;
                      response.data.result.forEach(urlGenerated => {

                          if(type =='sdk'){
                            this.newSdk.sdk = urlGenerated;
                            
                          }else if(type =='document'){
                            this.newSdk.document = urlGenerated;
                             if(!this.isAdd){
                                this.newDocument =true;

                              }
                          }
                          if (temp_count >= mapper.length) {
                              this.disabled_btn = false;
                              this.$vs.loading.close();
                          }

                          doc.url = urlGenerated;
                          delete doc.file;
                          mapper[index] = doc;

                      });
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }
            } else {
              this.$vs.notify({
            title: "Error",
            text: 'The format of the file you chose to upload is not supported',
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
            }

          
           

          
      },
  createSdkAction(){
    //popupcreateticket = false
    // let companyIds = [];
    // let cusIds = [];
     
    let payload = {
      description : this.newSdk.description,
      title : this.newSdk.title.trim(),
      version : this.newSdk.version,
      cusIds : this.newSdk.cusIds,
      companyIds : this.newSdk.companyIds,
      sdk : this.newSdk.sdk,
      document : this.newSdk.document
    }
    if (payload.companyIds && payload.companyIds.length > 0) {
      payload.companyIds = payload.companyIds.map(item => item._id)
    }
     if (payload.cusIds && payload.cusIds.length > 0) {
      payload.cusIds = payload.cusIds.map(item => item._id)
    }
   // payload.companyIds = companyIds;
     //payload.cusIds = cusIds;
     this.$vs.loading()
      this.$store
        .dispatch("uploadSdk", payload)
        .then((response) => {
         this.popupcreateticket = false
           this.$vs.loading.close();
           this.getSdkList();
          this.$vs.notify({
            title: "Success",
            text: response.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((err) => {
          //alert(JSON.stringify(err));
          console.log(err);
           
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.error_message.message,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });

  },
      change_perPage() {
        this.page = 1;

        this.getSdkList();
      },
      createSdk(){
        this.isAdd =true,
        this.popupTitle ="Add SDK Release";
        this.radios1 = "EveryOne"
        this.popupcreateticket = true;
        this.init();
      },
      init() {
        this.newSdk ={
          "description":"",
          "title": "",
          "version": "",
          "cusIds": [],
          "pubContent": null,
          "companyIds": [],
          "sdk": null,
          "document": null
        }
      },
        
    getSdkList(){
       const postData = {
        filters: {"title":this.serch_title},
        sorting: this.sortKey, //{"path": "name","order": -1	},
        page: this.page,
        perpage: this.perPage,
      };
     
      if(!this.callFromSort){
            this.sdkList = [];
      }
      this.callFromSort = false;
       
       this.loading =true;
       this.$vs.loading()
      this.$store
        .dispatch("getSdkList", postData)
        .then((response) => {
          this.sdkList = response.list;
          
          this.totalpages = Math.ceil(response.totalCount / this.perPage);
           this.loading =false;
           this.$vs.loading.close();
          
        })
        .catch((err) => {
          console.log(err);
           this.loading =false;
          this.$vs.loading.close();
          
        });

    },
    sortMe(sort_key = "") {
      this.sortKey = { path: "createdOn", order: 1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        this.getSdkList();
      }
    },
    updateSdkAction(){
    //   if (this.newSdk.companyIds && this.newSdk.companyIds.length > 0) {
    //   this.newSdk.companyIds = this.newSdk.companyIds.map(item => item._id)
    // }
    //  if (this.newSdk.cusIds && this.newSdk.cusIds.length > 0) {
    //   this.newSdk.cusIds = this.newSdk.cusIds.map(item => item._id)
    // }
    let payload = {
      sdkId: this.newSdk._id,
      description : this.newSdk.description,
      title : this.newSdk.title.trim(),
      version : this.newSdk.version,
      cusIds : this.newSdk.cusIds,
      companyIds : this.newSdk.companyIds,
      sdk : this.newSdk.sdk,
      document : this.newSdk.document
    }
    if (payload.companyIds && payload.companyIds.length > 0) {
      payload.companyIds = payload.companyIds.map(item => item._id)
    }
     if (payload.cusIds && payload.cusIds.length > 0) {
      payload.cusIds = payload.cusIds.map(item => item._id)
    }
    //popupcreateticket = false
    if(this.newDocument){
      payload['newDocument'] = true; 

    }
     this.$vs.loading();
     //this.newSdk['sdkId'] =this.newSdk['_id'];
      this.$store
        .dispatch("updateSdk", payload)
        .then((response) => {
          this.newDocument =false;
         this.popupcreateticket = false
           this.$vs.loading.close();
           this.getSdkList();
          this.$vs.notify({
            title: "Success",
            text: response.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((err) => {
          //console.log(err);
           
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.error_message.message,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });

  },
    // handleSelected(tr) {
    //   this.$vs.notify({
    //     title:`Selected ${tr.username}`,
    //     text:`Email: ${tr.email}`
    //   })
    // },
    // prueba(){
    //   console.log("prueba de focsu");
    // },
    // doubleSelection(tr) {
    //   this.$vs.notify({
    //     title:`Double Selection ${tr.username}`,
    //     text:`Email: ${tr.email}`,
    //     color: 'success'
    //   })
    // }, 
    clearFilters() {
      this.filtersList =false;
      this.serch_title = '';
      this.getSdkList();
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: 'All',
        value: 'all'
      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    downloadFile(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }
      this.selectedFile = value;
      this.docValue ='';
      this.docPrivew =false;
      this.docType =false;
      this.docType = this.findmsDoctype(value['extn']);
    if(this.docType=="office" || this.docType == "image" || this.docType == "pdf" ){
      value.url = value.url.replace(  "https://deepvisioninv.s3.ap-south-1.amazonaws.com/",  ""  );
      let postdata = { keyName: value.url };
      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        this.docValue =  response.data.result.data;
        if(this.docType=="office" ){
          this.docValue =  encodeURIComponent(response.data.result.data);
        }
      
      this.docPrivew =true;
      
      //window.open(response.data.result.data, "_blank");
    });

    }else{
      this.download_file(value );
    }
    
    // let postdata = { keyName: value.path , "taskId": this.taskDetails['_id']};
    

    
  },
  download_file(value ,sdkBucket=false) {
       
        if(_.has(value , "path")){
          value['url'] = value['path'];
        }
        if(_.has(value , "url")){
          value['path'] = value['url'];
        }

       // value.url = value.url.replace( "https://deepvisioninv.s3.eu-west-1.amazonaws.com/", "");
        // let postdata = { keyName: value.path , "taskId": this.taskDetails['_id']};
        let postdata = { keyName: value.url };
        if(sdkBucket){
          postdata['sdkBucket']  = true;
        }
  
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          
          window.open(response.data.result.data, "_blank");
         // window.location.href = response.data.result.data;
        });
      },

       findmsDoctype(ext=''){
        let docTypes =[
          'doc' ,"docx","txt","odt","rtf","dotm","wps","xml",
          "xl","xlsx","xla","xlsb"
        ]
        let imagTypes = ['jpeg','jpg' ,'png'];
        let pdfTypes =['pdf']
        if( _.findIndex(docTypes ,(vl)=>{ return vl==ext} ) !=-1){
          return "office";
        }else if( _.findIndex(imagTypes ,(vl)=>{ return vl==ext} ) !=-1){
          return "image";

        }else if( _.findIndex(pdfTypes ,(vl)=>{ return vl==ext} ) !=-1){
          
          return "pdf";
        
        }else {
          return false;
        }

      },
      onEnter() {
        this.getSdkList();
    },
     searchCustomerList(val=''){
       this.sdkUsers =[];
      this.searchCustomer = val;
      this.getCustomerList();
    }, 
    getCustomerList() {
      //let postData = {"matcher":{"title":this.searchCustomer,"roleIds":[2],"statusIds":[],"createdOnRange":[] ,"companyIds":[]},"sorting":{"path":"createdOn","order":1},"page":1,"perpage":25};
     
     let postData ={
        "matcher": {
            "searchString": this.searchCustomer,
            "companyIds": []
        },
        "page": 1,
        "perpage": 1000,
        "category": "cusomers_by_login_user"
    }
          
     //filterData.customerIds
      this.sdkUsers = [];
      this.$store.dispatch("getMasterData" ,postData).then((response) => {
      //this.sdkUsers = response;
       let dt  = response.list;
          if(dt.length>0){
            _.forEach(dt ,(obj)=>{
              
              let cus = obj;
              if(_.has(obj ,"name") && _.has(obj ,"email") ){
                cus['name'] =  cus['name']+" ("+obj['email']+")"
              }
              let isExists =_.find(this.sdkUsers ,{"_id":obj['_id']})
              if(!isExists){
                this.sdkUsers.push(cus);
              }
              



            });

          }

      
    });
    },
  },
  mounted(){
    
    this.sortKey = { path: "createdOn", order: -1 };
    document.cookie = "accessToken="+this.activeUserInfo['accessToken'];
    this.getSdkList();
    this.apiURL = axios.defaults.baseURL;
     this.$store.dispatch("getCompanies").then((response) => {
      this.companies = response;
    });
    this.sdkUsers =[];
    this.getCustomerList();
    this.getsdkBucketList('sdkBucketList');
    this.getsdkBucketList('sdkDocBucketList');
   

  },
  watch:{
     publishPopup:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }        
    },
    popupcreateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    }

  },
}
</script>
<style  lang="scss">
.con-expand-users {
  .con-btns-user {
    display: flex;
    padding: 10px;
    padding-bottom: 0px;
    align-items: center;
    justify-content: space-between;
    .con-userx {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .list-icon {
        i {
          font-size: 0.9rem !important;
        }
      }
    }
  }
}
</style>